import type { RefObject } from 'react';
import { findTransitionController } from '../../../util/core-transition-component';
import type { LogoIntroSectionRef } from './logo-intro-section/LogoIntroSection.data';

interface HeaderIntroRefs {
  elementRef: RefObject<HTMLElement | null>;

  logoIntroSectionRef?: RefObject<LogoIntroSectionRef | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { logoIntroSectionRef }: HeaderIntroRefs,
): void {
  // todo maybe only fade-in when we are not 'landing'(no store.fromPath) here:
  // timeline.add(fadeFromTo(elementRef.current as HTMLElement));
  const logoIntroSectionController = findTransitionController(logoIntroSectionRef);

  if (logoIntroSectionController) {
    timeline.add(logoIntroSectionController.getTimeline('in') as gsap.core.Timeline, 0);
  }
}
